import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal, Form } from 'antd';
import PromoForm from './PromoForm';

class CreatePromoModal extends Component {
  render = () => {
    const { onOk, onCancel, visible, form } = this.props;

    const promo = {
      start_date: Date.now() / 1000,
      end_date: Date.now() / 1000,
    };

    return (
      <Modal title="Create Promotion" visible={visible} onCancel={onCancel} onOk={onOk}>
        <PromoForm form={form} promo={promo} />
      </Modal>
    );
  };
}

CreatePromoModal.proptypes = {
  onOk: PropTypes.func.isRequired,
  visible: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  form: PropTypes.object.isRequired,
};

const ModalForm = Form.create()(CreatePromoModal);

export default ModalForm;



// WEBPACK FOOTER //
// ./src/components/Promo/CreatePromoModal.js